<script setup lang="ts">
import UpsellModal from './UpsellModal.vue'
import useMerchant from '@/composables/merchant'

const { stores, user, displaySmsPackUpsellBanner } = useLocalStorage()
const { isEligibleForSmsUpsell } = useMerchant()

const { t } = useI18n()
const { send } = useEvent()

const schedulingPlatform =
  'https://calendly.com/pongo-team/demo?utm_source=pongo&utm_medium=dashboard&utm_campaign=conversion-self-served&utm_content=dashboard'

const helperCardTitle = {
  title: t('upsell.banner.smsPack.modal.helperCard.title'),
  steps: [t('upsell.banner.smsPack.modal.helperCard.step1'), t('upsell.banner.smsPack.modal.helperCard.step2')]
}
const success = {
  title: t('upsell.banner.smsPack.modal.success.title'),
  text: t('upsell.banner.smsPack.modal.success.text'),
  linkText: t('upsell.banner.smsPack.modal.success.linkText')
}
const links = {
  reminder: schedulingPlatform,
  activate: '#'
}

const activateSmsPacks = (selectedStores) => {
  selectedStores.forEach((selectedStore) => {
    const storeData = stores.value.find((store) => store.id === selectedStore.storeId)

    const data = {
      merchantPublicId: user.value.merchant.publicId,
      merchantName: user.value.merchant.name,
      crmOwnerIdentifier: storeData.ownerCsm?.crmContactIdentifier.toString(),
      crmDealIdentifier: storeData.businessCrmIdentifier?.toString(),
      crmCompanyIdentifier: user.value.merchant.businessCrmIdentifier?.toString(),
      storeId: storeData.id,
      storePublicId: storeData.public_id,
      storeName: storeData.name,
      product: {
        productName: 'packSms',
        packSmsId: selectedStore.packSmsId,
        packSms: selectedStore.packSms,
        price: selectedStore.price
      }
    }
    send('segment', 'product:create:clicked', data)
    closeBanner()
  })
}

const isModalFromBannerOpened = ref(false)

const closeBanner = () => {
  displaySmsPackUpsellBanner.value = false
}

const deadline = (month, day) => {
  const today = new Date()
  return today < new Date(today.getFullYear(), month, day)
}

const openModalFromBanner = () => {
  send('segment', 'product:viewed')
  isModalFromBannerOpened.value = true
}

const handleSchedulingRedirection = () => {
  send('segment', 'scheduling.new:clicked')
  isModalFromBannerOpened.value = false
}

const continueTrackingEvent = 'product:new:viewed'

const isBannerVisible = computed(
  () => deadline(6, 1) && displaySmsPackUpsellBanner.value && isEligibleForSmsUpsell.value
)
</script>

<template>
  <div
    v-if="isBannerVisible"
    class="sticky top-0 z-40 flex h-auto w-full justify-center border-red-700 bg-brand p-3 px-8 text-center text-xs text-white sm:h-10 sm:text-sm md:items-center md:px-0"
  >
    <button type="button" class="flex items-center" @click="openModalFromBanner">
      <BaseIcon name="HeroArrowUpCircleIconSolid" class="a aspect-square w-12 sm:mr-1.5 sm:w-4" />
      <p>
        {{ t('upsell.banner.smsPack.title') }}
        <span class="underline hover:cursor-pointer">
          {{ t('upsell.banner.smsPack.underlinedOffer') }}
        </span>
      </p>
    </button>

    <button type="button" class="absolute right-4 text-white" @click="closeBanner">
      <BaseIcon name="HeroXMarkIconSolid" class="h5 w-5" />
    </button>
  </div>

  <UpsellModal
    :title="t('upsell.banner.smsPack.modal.addPackTitle')"
    :show="isModalFromBannerOpened"
    :helper-card="helperCardTitle"
    is-sms
    :success="success"
    :links="links"
    :continue-tracking-event="continueTrackingEvent"
    @on-close-modal="handleSchedulingRedirection"
    @on-activate="activateSmsPacks"
  />
</template>
